<link rel="stylesheet"
      href="../../../../../../../Users/alexboey/Downloads/LandingPage_county_dropdown_text_visible_fix.css">
<template>
  <div class="category-browse-root" :style="themePageStyle">
    <head>
      <meta charset="utf-8" />
      <title>FLOCKR | {{ speciesName || 'Browse Category' }}</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Browse livestock by category" name="description" />
      <meta content="Flockr" name="author" />
      <link rel="shortcut icon" href="/assets/images/favicon.svg">
      <link href="/assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
      <link href="/assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />
      <link href="/assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
      <link href="/assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <link href="/assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <link href="/assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body :data-sidebar="darkMode ? 'dark' : 'light'">
    <div id="layout-wrapper">

      <!-- ========== TOP BAR ========== -->
      <nav class="cb-topbar">
        <div class="container d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center" style="gap:16px;">
            <a href="javascript:void(0)" @click="$router.push('/')">
              <img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" />
            </a>
            <button class="btn btn-sm btn-link text-muted p-0" @click="$router.push('/marketplace')">
              <i class="mdi mdi-arrow-left me-1"></i> Marketplace
            </button>
          </div>
          <div class="d-flex align-items-center" style="gap:12px;">
            <a href="javascript:void(0)" @click="$router.push('/marketplace/search')" class="text-muted" style="font-size:13px;text-decoration:none;">
              <i class="mdi mdi-magnify me-1"></i> Search
            </a>
          </div>
        </div>
      </nav>

      <!-- ========== LOADING ========== -->
      <div v-if="loading" class="text-center py-5" style="padding-top:100px!important;">
        <div class="spinner-border text-warning" role="status"></div>
        <p class="mt-3" style="color:var(--fm-s,#777);">Loading category...</p>
      </div>

      <!-- ========== CONTENT ========== -->
      <div v-else class="container cb-container">

        <!-- ===== HERO BANNER ===== -->
        <div class="cb-hero">
          <div class="cb-hero-icon">
            <i :class="getSpeciesIcon(speciesName)" style="font-size:48px;color:#BFA164!important;"></i>
          </div>
          <div>
            <h2 class="cb-hero-title">{{ speciesName }}</h2>
            <p class="cb-hero-sub">
              Browse {{ breeds.length }} breed{{ breeds.length !== 1 ? 's' : '' }} · {{ totalListings }} active listing{{ totalListings !== 1 ? 's' : '' }}
            </p>
          </div>
          <div class="ms-auto d-none d-md-block">
            <button class="btn btn-warning btn-sm" @click="viewAllListings">
              <i class="mdi mdi-magnify me-1"></i> View All {{ speciesName }} Listings
            </button>
          </div>
        </div>

        <!-- ===== ALL SPECIES (Horizontal Scroll) ===== -->
        <div class="cb-species-scroll mb-4">
          <button v-for="sp in allSpecies" :key="sp.id"
                  class="cb-species-chip" :class="{ active: String(sp.id) === String(speciesId) }"
                  @click="switchSpecies(sp.id)">
            <i :class="getSpeciesIcon(sp.name)" style="font-size:16px;"></i>
            <span>{{ sp.name }}</span>
          </button>
        </div>

        <!-- ===== BREEDS GRID ===== -->
        <div class="cb-section" v-if="breeds.length > 0">
          <h5 class="cb-section-title"><i class="mdi mdi-dna me-2"></i>Popular Breeds</h5>
          <div class="row g-3">
            <div class="col-6 col-md-4 col-lg-3" v-for="breed in breeds" :key="breed.id">
              <div class="cb-breed-card" @click="browseBreed(breed.id)">
                <div class="cb-breed-icon">
                  <i :class="getSpeciesIcon(speciesName)" style="font-size:28px;color:#BFA164!important;opacity:0.6;"></i>
                </div>
                <div class="cb-breed-name">{{ breed.name }}</div>
                <div class="cb-breed-meta" v-if="breed.origin_country">{{ breed.origin_country }}</div>
                <div class="cb-breed-meta" v-if="breed.avg_weight_kg">~{{ breed.avg_weight_kg }}kg avg</div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===== FEATURED LISTINGS ===== -->
        <div class="cb-section">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h5 class="cb-section-title mb-0"><i class="mdi mdi-fire me-2"></i>Featured {{ speciesName }}</h5>
            <a href="javascript:void(0)" @click="viewAllListings" style="color:#BFA164!important;font-size:13px;text-decoration:none;font-weight:600;">
              See All <i class="mdi mdi-arrow-right"></i>
            </a>
          </div>

          <div v-if="loadingFeatured" class="text-center py-4">
            <div class="spinner-border spinner-border-sm text-warning"></div>
          </div>

          <div v-else-if="featuredListings.length === 0" class="text-center py-4">
            <i class="mdi mdi-tag-off-outline" style="font-size:40px;color:var(--fm-s,#3A3530);"></i>
            <p class="mt-2" style="color:var(--fm-s,#777);font-size:14px;">No featured listings in this category yet</p>
          </div>

          <div v-else class="row g-3">
            <div class="col-6 col-md-4 col-lg-3" v-for="item in featuredListings" :key="'f-'+item.id">
              <div class="cb-listing-card" @click="$router.push('/marketplace/listing/' + item.id)">
                <div class="cb-listing-img">
                  <img v-if="item.primary_photo" :src="photoUrl(item.primary_photo)" :alt="item.title" />
                  <div v-else class="cb-listing-placeholder">
                    <i :class="getSpeciesIcon(item.species_name)" style="font-size:36px;color:rgba(191,161,100,0.3);"></i>
                  </div>
                  <div class="cb-listing-badges">
                    <span v-if="item.seller_verified" class="badge bg-success" style="font-size:9px;" title="Seller KYC verified"><i class="mdi mdi-check-decagram"></i></span><span v-if="Number(item.vet_verified) === 1" class="badge bg-info ms-1" style="font-size:9px;" title="Vet-verified animal"><i class="mdi mdi-stethoscope"></i></span>
                  </div>
                  <button class="cb-save-btn" @click.stop="toggleSave(item)">
                    <i class="mdi" :class="item.is_saved ? 'mdi-heart text-danger' : 'mdi-heart-outline'"></i>
                  </button>
                </div>
                <div class="cb-listing-body">
                  <div class="cb-listing-title">{{ item.title }}</div>
                  <div class="cb-listing-price">{{ (item.currency || 'KES') }} {{ formatPrice(item.price) }}</div>
                  <div class="cb-listing-meta">
                    <span v-if="item.breed_name">{{ item.breed_name }}</span>
                    <span v-if="item.county_name"> · {{ item.county_name }}</span>
                  </div>
                  <div class="cb-listing-seller" v-if="item.seller_name">
                    <div class="cb-seller-dot">{{ getInitials(item.seller_name) }}</div>
                    <span>{{ item.seller_name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===== RECENT LISTINGS ===== -->
        <div class="cb-section">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h5 class="cb-section-title mb-0"><i class="mdi mdi-clock-outline me-2"></i>Latest {{ speciesName }}</h5>
            <a href="javascript:void(0)" @click="viewAllListings" style="color:#BFA164!important;font-size:13px;text-decoration:none;font-weight:600;">
              See All <i class="mdi mdi-arrow-right"></i>
            </a>
          </div>

          <div v-if="loadingRecent" class="text-center py-4">
            <div class="spinner-border spinner-border-sm text-warning"></div>
          </div>

          <div v-else-if="recentListings.length === 0" class="text-center py-4">
            <i class="mdi mdi-tag-off-outline" style="font-size:40px;color:var(--fm-s,#3A3530);"></i>
            <p class="mt-2" style="color:var(--fm-s,#777);font-size:14px;">No recent listings found</p>
          </div>

          <div v-else class="row g-3">
            <div class="col-6 col-md-4 col-lg-3" v-for="item in recentListings" :key="'r-'+item.id">
              <div class="cb-listing-card" @click="$router.push('/marketplace/listing/' + item.id)">
                <div class="cb-listing-img">
                  <img v-if="item.primary_photo" :src="photoUrl(item.primary_photo)" :alt="item.title" />
                  <div v-else class="cb-listing-placeholder">
                    <i :class="getSpeciesIcon(item.species_name)" style="font-size:36px;color:rgba(191,161,100,0.3);"></i>
                  </div>
                  <button class="cb-save-btn" @click.stop="toggleSave(item)">
                    <i class="mdi" :class="item.is_saved ? 'mdi-heart text-danger' : 'mdi-heart-outline'"></i>
                  </button>
                </div>
                <div class="cb-listing-body">
                  <div class="cb-listing-title">{{ item.title }}</div>
                  <div class="cb-listing-price">{{ (item.currency || 'KES') }} {{ formatPrice(item.price) }}</div>
                  <div class="cb-listing-meta">
                    <span v-if="item.breed_name">{{ item.breed_name }}</span>
                    <span v-if="item.county_name"> · {{ item.county_name }}</span>
                  </div>
                  <div class="cb-listing-seller" v-if="item.seller_name">
                    <div class="cb-seller-dot">{{ getInitials(item.seller_name) }}</div>
                    <span>{{ item.seller_name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===== MARKET PRICES ===== -->
        <div class="cb-section" v-if="marketPrices.length > 0">
          <h5 class="cb-section-title"><i class="mdi mdi-chart-line me-2"></i>{{ speciesName }} Market Prices</h5>
          <div class="row g-3">
            <div class="col-6 col-md-4" v-for="(mp, mi) in marketPrices" :key="'mp-'+mi">
              <div class="cb-price-card">
                <div class="cb-price-breed">{{ mp.breed_name || speciesName }}</div>
                <div class="cb-price-county" v-if="mp.county_name">{{ mp.county_name }}</div>
                <div class="cb-price-value">{{ (mp.currency || 'KES') }} {{ formatPrice(mp.avg_price) }}</div>
                <div class="cb-price-range" v-if="mp.min_price && mp.max_price">
                  {{ formatPrice(mp.min_price) }} – {{ formatPrice(mp.max_price) }}
                </div>
                <div class="cb-price-meta" v-if="mp.sample_size">Based on {{ mp.sample_size }} sale{{ mp.sample_size > 1 ? 's' : '' }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===== MOBILE CTA ===== -->
        <div class="d-md-none text-center py-3">
          <button class="btn btn-warning w-100" @click="viewAllListings">
            <i class="mdi mdi-magnify me-1"></i> View All {{ speciesName }} Listings
          </button>
        </div>

      </div>

    </div>
    </body>
  </div>
</template>

<!-- ========== STYLES ========== -->
<style>

/* === GLOBAL THEME === */
html[data-theme="light"] body { background:#FFFFFF!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-card,html[data-theme="light"] .p2c,html[data-theme="light"] .ld-section,html[data-theme="light"] .ld-action-card,html[data-theme="light"] .ld-seller-card,html[data-theme="light"] .ld-info-card,html[data-theme="light"] .ld-related-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-overlay .fm-modal,html[data-theme="light"] .ad-overlay .ad-modal { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-input,html[data-theme="light"] .fm-select { background:#F7F5F2!important; border-color:#E0D8D0!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-label { color:#555!important; }
html[data-theme="dark"] body { background:#0A0A0A!important; color:#F5F0E8!important; }
</style>
<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .card-body{color:#1A1A1A!important}
html[data-theme="light"] .modal-content{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .form-control,html[data-theme="light"] .form-select{background:#FFFFFF!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
html[data-theme="light"] .table{color:#1A1A1A!important}
html[data-theme="light"] .table th{color:#555!important;border-color:#E8E2DA!important}
html[data-theme="light"] .table td{border-color:#F0EBE4!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] [style*="background:#0F0F0F"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#141414"]{background:#FFFFFF!important}
html[data-theme="light"] [style*="background:#1E1E1E"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0A0A0A"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#1a1510"]{background:#FFF8F0!important}
html[data-theme="light"] [style*="background:#1A1A1A"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="border:1px solid #1E1E1E"]{border-color:#E8E2DA!important}
html[data-theme="light"] [style*="border:1px solid #2A2520"]{border-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1A1A1A"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1E1E1E"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #2A2520"]{border-bottom-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-top:1px solid #2A2520"]{border-top-color:#E0D8D0!important}
html[data-theme="light"] [style*="color:#BFA164"]{color:#BFA164!important}
html[data-theme="light"] [style*="color:#50C878"]{color:#50C878!important}
html[data-theme="light"] [style*="color:#4FC3F7"]{color:#4FC3F7!important}
html[data-theme="light"] [style*="color:#FF6B6B"]{color:#FF6B6B!important}
html[data-theme="light"] [style*="color:#FF9800"]{color:#FF9800!important}
html[data-theme="light"] [style*="color:#CE93D8"]{color:#CE93D8!important}
</style>
<style>
html[data-theme="light"] .category-browse-root,
html[data-theme="light"] #layout-wrapper,
html[data-theme="light"] .cb-container {
  background:#F7F5F2!important;
  color:#1A1A1A!important;
}
html[data-theme="dark"] .category-browse-root,
html[data-theme="dark"] #layout-wrapper,
html[data-theme="dark"] .cb-container {
  background:#0A0A0A!important;
  color:#F5F0E8!important;
}
html[data-theme="light"] .cb-topbar{
  background:#FFFFFF!important;
  border-bottom-color:#E8E2DA!important;
}
html[data-theme="dark"] .cb-topbar{
  background:rgba(10,10,10,0.95)!important;
}
html[data-theme="light"] .cb-hero,
html[data-theme="light"] .cb-breed-card,
html[data-theme="light"] .cb-listing-card,
html[data-theme="light"] .cb-price-card,
html[data-theme="light"] .cb-species-chip {
  background:#FFFFFF!important;
  border-color:#E8E2DA!important;
  color:#1A1A1A!important;
}
html[data-theme="light"] .cb-listing-img{
  background:#F0EBE4!important;
}
html[data-theme="light"] .cb-save-btn{
  background:rgba(255,255,255,0.9)!important;
  color:#1A1A1A!important;
}
html[data-theme="light"] .cb-hero-sub,
html[data-theme="light"] .cb-listing-meta,
html[data-theme="light"] .cb-listing-seller,
html[data-theme="light"] .cb-breed-meta,
html[data-theme="light"] .cb-price-range,
html[data-theme="light"] .cb-price-county,
html[data-theme="light"] .cb-price-meta{
  color:#555!important;
}
</style>
<style scoped>
.category-browse-root { background:var(--fm-bg2,#0F0F0F)!important; min-height:100vh; color:var(--fm-h,#F5F0E8)!important; }

.cb-topbar {
  position:sticky; top:0; z-index:100; padding:12px 0;
  background:var(--fm-bg1,#141414)!important; backdrop-filter:blur(10px);
  border-bottom:1px solid var(--fm-br,#1E1E1E);
}

.cb-container { padding-top:80px; padding-bottom:60px; max-width:1140px; }

/* Hero */
.cb-hero {
  display:flex; align-items:center; gap:20px;
  background:var(--fm-bg1,#141414)!important; border:1px solid var(--fm-br,#1E1E1E); border-radius:12px;
  padding:24px; margin-bottom:24px;
}
.cb-hero-icon {
  width:80px; height:80px; border-radius:50%; flex-shrink:0;
  background:rgba(191,161,100,0.08); border:2px solid var(--fm-br,#2A2520);
  display:flex; align-items:center; justify-content:center;
}
.cb-hero-title { font-size:28px; font-weight:700; color:var(--fm-h,#F5F0E8); margin:0; }
.cb-hero-sub { font-size:14px; color:var(--fm-m,#555); margin:4px 0 0 0; }

/* Species Scroll */
.cb-species-scroll {
  display:flex; gap:8px; overflow-x:auto; padding-bottom:8px;
  scrollbar-width:none; -ms-overflow-style:none;
}
.cb-species-scroll::-webkit-scrollbar { display:none; }
.cb-species-chip {
  display:flex; align-items:center; gap:6px; white-space:nowrap;
  padding:8px 16px; border-radius:20px; border:1px solid var(--fm-br,#2A2520);
  background:var(--fm-bg1,#141414)!important; color:var(--fm-m,#555555)!important; font-size:13px; cursor:pointer;
  transition:all 0.2s ease;
}
.cb-species-chip:hover { border-color:#BFA164!important; color:#BFA164; }
.cb-species-chip.active {
  background:rgba(191,161,100,0.15); border-color:#BFA164!important; color:#BFA164; font-weight:600;
}

/* Sections */
.cb-section { margin-bottom:32px; }
.cb-section-title { font-size:16px; font-weight:700; color:#BFA164; }

/* Breed Cards */
.cb-breed-card {
  background:var(--fm-bg1,#141414)!important; border:1px solid var(--fm-br,#1E1E1E); border-radius:10px;
  padding:16px; text-align:center; cursor:pointer; transition:all 0.2s ease;
}
.cb-breed-card:hover { border-color:#BFA164!important; transform:translateY(-2px); }
.cb-breed-icon { margin-bottom:8px; }
.cb-breed-name { font-size:14px; font-weight:600; color:var(--fm-h,#F5F0E8); margin-bottom:4px; }
.cb-breed-meta { font-size:11px; color:var(--fm-m,#A09888); }

/* Listing Cards */
.cb-listing-card {
  background:var(--fm-bg1,#141414)!important; border:1px solid var(--fm-br,#1E1E1E); border-radius:10px;
  overflow:hidden; cursor:pointer; transition:all 0.2s ease;
}
.cb-listing-card:hover { border-color:#BFA164!important; transform:translateY(-2px); }
.cb-listing-img {
  position:relative; height:150px; overflow:hidden; background:var(--fm-bg2,#0F0F0F)!important;
}
.cb-listing-img img { width:100%; height:100%; object-fit:cover; }
.cb-listing-placeholder {
  width:100%; height:100%; display:flex; align-items:center; justify-content:center;
}
.cb-listing-badges { position:absolute; top:8px; left:8px; display:flex; gap:4px; }
.cb-save-btn {
  position:absolute; top:8px; right:8px; background:rgba(0,0,0,0.5);
  border:none; border-radius:50%; width:30px; height:30px;
  display:flex; align-items:center; justify-content:center;
  color:var(--fm-h,#F5F0E8); font-size:15px; cursor:pointer; transition:all 0.2s ease;
}
.cb-save-btn:hover { background:rgba(0,0,0,0.8); }
.cb-listing-body { padding:12px; }
.cb-listing-title {
  font-size:13px; font-weight:600; color:var(--fm-h,#F5F0E8); margin-bottom:4px;
  white-space:nowrap; overflow:hidden; text-overflow:ellipsis;
}
.cb-listing-price { font-size:15px; font-weight:700; color:#BFA164; margin-bottom:4px; }
.cb-listing-meta { font-size:11px; color:var(--fm-m,#A09888); margin-bottom:6px; }
.cb-listing-seller { display:flex; align-items:center; gap:6px; font-size:11px; color:var(--fm-m,#A09888); }
.cb-seller-dot {
  width:20px; height:20px; border-radius:50%; background:var(--fm-bg3,#1E1E1E);
  display:flex; align-items:center; justify-content:center;
  font-size:8px; font-weight:700; color:#BFA164;
}

/* Market Prices */
.cb-price-card {
  background:var(--fm-bg1,#141414)!important; border:1px solid var(--fm-br,#1E1E1E); border-radius:10px;
  padding:16px; text-align:center;
}
.cb-price-breed { font-size:14px; font-weight:600; color:var(--fm-h,#F5F0E8); margin-bottom:2px; }
.cb-price-county { font-size:11px; color:var(--fm-m,#A09888); margin-bottom:8px; }
.cb-price-value { font-size:20px; font-weight:700; color:#BFA164; }
.cb-price-range { font-size:11px; color:var(--fm-m,#A09888); margin-top:2px; }
.cb-price-meta { font-size:10px; color:var(--fm-s,#6B6356); margin-top:4px; }

@media (max-width: 768px) {
  .cb-container { padding-top:70px; }
  .cb-hero { flex-wrap:wrap; padding:16px; }
  .cb-hero-icon { width:56px; height:56px; }
  .cb-hero-icon i { font-size:32px!important; }
  .cb-hero-title { font-size:22px; }
  .cb-listing-img { height:120px; }
  .cb-container { padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px)); }
}
</style>

<!-- ========== SCRIPT ========== -->
<script>

/* eslint-disable */
import { executeJson, flocker, uploads } from "@/api";

function applyCategoryTheme(vm) {
  const t = document.documentElement.getAttribute('data-theme') || localStorage.getItem('flockr_theme') || (vm && vm.darkMode ? 'dark' : 'light');
  const isDark = t !== 'light';
  if (vm) vm.darkMode = isDark;
  window.__flockrSetTheme(isDark ? 'dark' : 'light');

  if (document.body) {
    document.body.setAttribute('data-sidebar', isDark ? 'dark' : 'light');
    document.body.style.background = isDark ? '#0A0A0A' : '#F7F5F2';
    document.body.style.color = isDark ? '#F5F0E8' : '#1A1A1A';
  }

  const wrapper = document.getElementById('layout-wrapper');
  if (wrapper) {
    wrapper.style.background = isDark ? '#0A0A0A' : '#F7F5F2';
    wrapper.style.color = isDark ? '#F5F0E8' : '#1A1A1A';
  }
}

export default {

  name: "CategoryBrowse",
  data: function() {
    return {
      darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
      themeObserver:null,
      themeObserver:null,

      loading: true,
      loadingFeatured: true,
      loadingRecent: true,
      speciesId: null,
      speciesName: '',
      allSpecies: [],
      breeds: [],
      featuredListings: [],
      recentListings: [],
      marketPrices: [],
      totalListings: 0
    };
  },
  watch: {
    '$route.params.slug': function(newSlug) {
      if (newSlug) this.loadCategory(newSlug);
    }
  },
  mounted: function() {
    applyCategoryTheme(this);
    this.themeObserver = new MutationObserver(() => applyCategoryTheme(this));
    this.themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });

    var slug = this.$route.params.slug;
    if (slug) this.loadCategory(slug);
  },
  beforeUnmount: function() {
    if (this.themeObserver) {
      this.themeObserver.disconnect();
    }
  },
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    themeCardStyle(){return this.darkMode?'background:#141414!important;border:1px solid #1E1E1E!important;':'background:#FFFFFF!important;border:1px solid #E8E2DA!important;'},
    themeInputStyle(){return this.darkMode?'background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;':'background:#FFFFFF;border:1px solid #E0D8D0;color:#1A1A1A;'},
  },
  methods: {

    photoUrl(p){if(!p)return'';if(p.startsWith&&p.startsWith('http'))return p;return uploads+String(p).replace('uploads/','')},


    // ============ LOAD ============

    async loadCategory(id) {
      this.loading = true;
      this.speciesId = id;
      this.breeds = [];
      this.featuredListings = [];
      this.recentListings = [];
      this.marketPrices = [];
      this.totalListings = 0;
      window.scrollTo({ top: 0 });

      try {
        await this.fetchAllSpecies();
        var sp = this.allSpecies.find(function(s) { return String(s.id) === String(id); });
        this.speciesName = sp ? sp.name : 'Unknown';

        this.fetchBreeds(id);
        this.fetchFeaturedListings(id);
        this.fetchRecentListings(id);
        this.fetchMarketPrices(id);
      } catch (e) {
        console.error('Error loading category:', e);
      } finally {
        this.loading = false;
      }
    },

    // ============ API ============

    async fetchAllSpecies() {
      try {
        var response = await executeJson({ function: "getAnimalSpecies" }, flocker);
        if (response.data.success) {
          this.allSpecies = response.data.data.species || [];
        }
      } catch (e) {
        console.error('Error fetching species:', e);
      }
    },

    async fetchBreeds(speciesId) {
      try {
        var response = await executeJson({
          function: "getAnimalBreeds",
          speciesId: speciesId
        }, flocker);
        if (response.data.success) {
          this.breeds = response.data.data.breeds || [];
        }
      } catch (e) {
        console.error('Error fetching breeds:', e);
      }
    },

    async fetchFeaturedListings(speciesId) {
      this.loadingFeatured = true;
      try {
        var response = await executeJson({
          function: "searchListings",
          speciesId: speciesId,
          sortBy: "popular",
          limit: 8,
          page: 1
        }, flocker);
        if (response.data.success) {
          this.featuredListings = response.data.data.listings || [];
          this.totalListings = response.data.data.total || 0;
        }
      } catch (e) {
        console.error('Error fetching featured:', e);
      } finally {
        this.loadingFeatured = false;
      }
    },

    async fetchRecentListings(speciesId) {
      this.loadingRecent = true;
      try {
        var response = await executeJson({
          function: "searchListings",
          speciesId: speciesId,
          sortBy: "newest",
          limit: 8,
          page: 1
        }, flocker);
        if (response.data.success) {
          this.recentListings = response.data.data.listings || [];
        }
      } catch (e) {
        console.error('Error fetching recent:', e);
      } finally {
        this.loadingRecent = false;
      }
    },

    async fetchMarketPrices(speciesId) {
      try {
        var response = await executeJson({
          function: "getMarketPrices",
          speciesId: speciesId,
          period: "weekly"
        }, flocker);
        if (response.data.success) {
          this.marketPrices = (response.data.data.prices || []).slice(0, 6);
        }
      } catch (e) {
        console.error('Error fetching prices:', e);
      }
    },

    // ============ ACTIONS ============

    switchSpecies: function(id) {
      this.$router.push('/marketplace/category/' + id);
    },

    viewAllListings: function() {
      this.$router.push({ path: '/marketplace/search', query: { speciesId: this.speciesId } });
    },

    browseBreed: function(breedId) {
      this.$router.push({ path: '/marketplace/search', query: { speciesId: this.speciesId, breedId: breedId } });
    },

    async toggleSave(item) {
      var userId = sessionStorage.getItem('userId');
      if (!userId) { this.$router.push('/login'); return; }
      try {
        var response = await executeJson({
          function: "saveListing",
          userId: userId,
          listingId: item.id
        }, flocker);
        if (response.data.success) {
          item.is_saved = !item.is_saved;
        }
      } catch (e) {
        console.error('Error toggling save:', e);
      }
    },

    // ============ FORMATTERS ============

    formatPrice: function(amount) {
      if (!amount) return '0';
      return Number(amount).toLocaleString('en-KE');
    },

    getInitials: function(name) {
      if (!name) return '?';
      return name.split(' ').map(function(w) { return w[0]; }).join('').substring(0, 2).toUpperCase();
    },

    getSpeciesIcon: function(species) {
      if (!species) return 'mdi mdi-help-circle-outline';
      var s = species.toLowerCase();
      if (s.indexOf('cattle') >= 0 || s.indexOf('cow') >= 0 || s.indexOf('bull') >= 0) return 'mdi mdi-cow';
      if (s.indexOf('goat') >= 0) return 'mdi mdi-unicode';
      if (s.indexOf('sheep') >= 0) return 'mdi mdi-sheep';
      if (s.indexOf('chicken') >= 0 || s.indexOf('poultry') >= 0) return 'mdi mdi-food-drumstick';
      if (s.indexOf('pig') >= 0 || s.indexOf('swine') >= 0) return 'mdi mdi-pig-variant-outline';
      if (s.indexOf('rabbit') >= 0) return 'mdi mdi-rabbit';
      if (s.indexOf('donkey') >= 0) return 'mdi mdi-horse-variant';
      if (s.indexOf('camel') >= 0) return 'mdi mdi-image-filter-hdr';
      if (s.indexOf('fish') >= 0 || s.indexOf('tilapia') >= 0) return 'mdi mdi-fish';
      if (s.indexOf('duck') >= 0 || s.indexOf('turkey') >= 0) return 'mdi mdi-duck';
      if (s.indexOf('bee') >= 0) return 'mdi mdi-bee';
      return 'mdi mdi-paw';
    }
  }
};
</script>
